import React, { createContext, useReducer } from "react";
import { SettingsReducer } from "./SettingsReducer";
import { MODAL_RESET } from "./SettingsConstant";

export const SettingsContext = createContext();

export const SettingsContextProvider = (props) => {
  const settingsInsight = {
    settingsData: {},
    showDeletePlanResponseModal: MODAL_RESET,
    showUpdatePlanResponseModal: MODAL_RESET,
    messageToDisplay: null,
  };

  const [viewModel, dispatch] = useReducer(SettingsReducer, settingsInsight);

  return (
    <SettingsContext.Provider value={{ viewModel, dispatch }}>
      {props.children}
    </SettingsContext.Provider>
  );
};

export default SettingsContextProvider;



// WEBPACK FOOTER //
// ./src/components/settings/SettingsContext.js